import { CartQueryShippingAddress } from '@app/types/monolith/types';

export const shippingAddressToCartParams = (
  address?: CartQueryShippingAddress | null
) => {
  if (!address) return null;

  const { countryCode, postcode, state } = address;

  return {
    ...(countryCode && { country_code: countryCode.toUpperCase() }),
    ...(postcode && { postcode }),
    ...(state && { state: state.toUpperCase() }),
  };
};
